/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resendconfirmationemaildescription3Inputs */

const en_resendconfirmationemaildescription3 = /** @type {(inputs: Resendconfirmationemaildescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send a new confirmation email to a business owner`)
};

const de_resendconfirmationemaildescription3 = /** @type {(inputs: Resendconfirmationemaildescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine neue Bestätigungs-E-Mail an einen Geschäftsinhaber senden`)
};

/**
* | output |
* | --- |
* | "Send a new confirmation email to a business owner" |
*
* @param {Resendconfirmationemaildescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const resendconfirmationemaildescription3 = /** @type {((inputs?: Resendconfirmationemaildescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resendconfirmationemaildescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resendconfirmationemaildescription3(inputs)
	return de_resendconfirmationemaildescription3(inputs)
});
export { resendconfirmationemaildescription3 as "resendConfirmationEmailDescription" }